module.exports = __webpack_public_path__ + "img/cadastro-clientes.c77bc2e2.jpg";